import { Fragment, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import ModalDialog from '../../../modalDialog/ModalDialog';
import ModalDialogContent from '../../../modalDialog/modalDialogContent/ModalDialogContent';
import ModalDialogButtons from '../../../modalDialog/modalDialogButtons/ModalDialogButtons';
import { AddSubscription, GetSubscriptionDetails, UpdateSubscription } from '../../../../Services';
import './SubscriptionDetailsDialog.css';
import Spinner from '../../../spinner/Spinner';

const SubscriptionDetailsDialog = ({ subscriptionId, onSubmit, onClose }) => {
	const [ isLoading, setIsLoading ] = useState(true);
	const [ isSaving, setIsSaving ] = useState(false);
	const [ formData, setFormData ] = useState({});

	useEffect(
		() => {
			getSubscription();
		},
		[ subscriptionId ]
	);

	const getSubscription = async () => {
		setIsLoading(true);

		if (subscriptionId) {
			let response = await GetSubscriptionDetails(subscriptionId);

			if (response) {
				setFormData(response);
			}
		}

		setIsLoading(false);
	};

	const handleChange = async (e) => {
		let type = e.target.type;
		let value = e.target.value;

		if (type === 'checkbox') {
			value = e.target.checked;
		}

		setFormData({
			...formData,
			[e.target.name]: value
		});
	};

	const handleSubmit = async () => {
		let isValid = document.querySelector('form').reportValidity();

		if (!isValid) {
			return;
		}

		setIsSaving(true);

		let data = { ...formData };

		let response;

		if (subscriptionId) {
			data.id = subscriptionId;
			response = await UpdateSubscription(subscriptionId, data);
		} else {
			response = await AddSubscription(data);
		}

		if (response.success) {
			if (onSubmit) {
				onSubmit();
			}

			toast.success('Subscription ' + (subscriptionId ? 'updated' : 'created') + ' successfully');
		}

		setIsSaving(false);
	};

	const handleOnCloseDialog = () => {
		if (onClose) {
			onClose();
		}
	};

	return (
		<Fragment>
			<ModalDialog position="right-sidebar" className="text-start">
				<ModalDialogContent align="start">
					{isLoading ? (
						<div className="text-center">
							<Spinner />
						</div>
					) : (
						<form className="row send-report-form">
							<div className="col-12 mb-3">
								<label htmlFor="name" className="form-label">
									Name:
								</label>
								<input
									type="text"
									className="form-control"
									name="name"
									value={formData.name || ''}
									onChange={handleChange}
									disabled={isSaving}
									required
								/>
							</div>
							<div className="col-12 mb-3">
								<label htmlFor="description" className="form-label">
									Description:
								</label>
								<textarea
									className="form-control"
									name="description"
									value={formData.description || ''}
									onChange={handleChange}
									disabled={isSaving}
									rows={3}
								/>
							</div>
							<div className="col-12 mb-3">
								<label htmlFor="amount" className="form-label">
									Amount:
								</label>
								<input
									type="number"
									className="form-control"
									name="amount"
									value={formData.amount || ''}
									onChange={handleChange}
									disabled={isSaving}
									required
								/>
							</div>
							<div className="col-12 mb-3">
								<label htmlFor="totalGridReports" className="form-label">
									Total Grid Reports:
								</label>
								<input
									type="number"
									className="form-control"
									name="totalGridReports"
									value={formData.totalGridReports || ''}
									onChange={handleChange}
									disabled={isSaving}
								/>
							</div>
							<div className="col-12 mb-3">
								<label htmlFor="totalAuditReports" className="form-label">
									Total Audit Reports:
								</label>
								<input
									type="number"
									className="form-control"
									name="totalAuditReports"
									value={formData.totalAuditReports || ''}
									onChange={handleChange}
									disabled={isSaving}
								/>
							</div>
							<div className="col-12 mb-3">
								<label htmlFor="totalCampaigns" className="form-label">
									Total Proximity Boost Campaigns:
								</label>
								<input
									type="number"
									className="form-control"
									name="totalCampaigns"
									value={formData.totalCampaigns || ''}
									onChange={handleChange}
									disabled={isSaving}
								/>
							</div>
						</form>
					)}
				</ModalDialogContent>
				<ModalDialogButtons>
					<button className="btn btn-primary" type="button" onClick={() => handleSubmit()}>
						{isSaving ? (
							<Fragment>
								<span className="spinner-border m-0 me-2" />
								<span>Saving</span>
							</Fragment>
						) : (
							<span>Save</span>
						)}
					</button>
					<button className="btn btn-outline-primary ms-2" type="button" onClick={handleOnCloseDialog}>
						Cancel
					</button>
				</ModalDialogButtons>
			</ModalDialog>
		</Fragment>
	);
};

export default SubscriptionDetailsDialog;
